export const DOMAIN_URL = process.env.NEXT_PUBLIC_BASE_URL as string;
export const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_DOMAIN as string;
export const GOOGLE_PRIVATE_KEY = process.env.GOOGLE_PRIVATE_KEY as string;
export const GOOGLE_CLIENT_EMAIL = process.env.GOOGLE_CLIENT_EMAIL as string;
export const GOOGLE_ID = process.env.NEXT_PUBLIC_GOOGLE_ID as string;
export const GOOGLE_SHEET_ID = process.env.GOOGLE_SHEET_ID as string;
export const STORYBLOK_KEY = process.env.STORYBLOK_KEY as string;
